/**
 * Kundens kategorier – segment och organisationstyp (listorna i kundformular.js).
 * Ett värde som inte finns i listan (äldre fritextsegment) visas som
 * "Tidigare: <värde>" tills det ändras; det sparas aldrig som nytt val.
 */
import React from 'react';
import { Box, TextField, MenuItem, Chip, Typography } from '@mui/material';
import { SEGMENT_OPTIONS, SEGMENT_BESKRIVNINGAR, ORGANISATIONSTYP_OPTIONS, segmentColor } from './kundformular';

const Prick = ({ farg }) => (
  <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: farg, flexShrink: 0, display: 'inline-block' }} />
);

function Valjare({ label, lista, value, onChange, farg, beskrivningar, ...props }) {
  const tidigare = value && !lista.includes(value) ? value : '';
  return (
    <TextField select size="small" label={label} value={value || ''} onChange={e => onChange(e.target.value)}
      helperText={(beskrivningar && beskrivningar[value]) || undefined}
      SelectProps={{
        renderValue: v => (v ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {farg && <Prick farg={farg(v)} />}
            {v === tidigare ? <i>Tidigare: {v}</i> : v}
          </Box>
        ) : ''),
      }}
      {...props}>
      <MenuItem value=""><Typography variant="body2" color="text.disabled">Inget valt</Typography></MenuItem>
      {tidigare && (
        <MenuItem value={tidigare} disabled>
          <Typography variant="body2" sx={{ fontStyle: 'italic' }}>Tidigare: {tidigare}</Typography>
        </MenuItem>
      )}
      {lista.map(o => (
        <MenuItem key={o} value={o} aria-label={o} aria-description={beskrivningar && beskrivningar[o]}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {farg && <Prick farg={farg(o)} />}
            <Box>
              {o}
              {beskrivningar && beskrivningar[o] && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.2, whiteSpace: 'normal' }}>
                  {beskrivningar[o]}
                </Typography>
              )}
            </Box>
          </Box>
        </MenuItem>
      ))}
    </TextField>
  );
}

export function SegmentValjare(props) {
  return <Valjare label="Segment" lista={SEGMENT_OPTIONS} farg={segmentColor} beskrivningar={SEGMENT_BESKRIVNINGAR} {...props} />;
}

export function OrganisationstypValjare(props) {
  return <Valjare label="Organisationstyp" lista={ORGANISATIONSTYP_OPTIONS} {...props} />;
}

/** Segmentet som etikett (leadkort, listor). Äldre fritext visas som "Tidigare: …". */
export function SegmentEtikett({ segment, liten }) {
  if (!segment) return null;
  const iLista = SEGMENT_OPTIONS.includes(segment);
  return (
    <Chip size="small" data-testid="segment-etikett"
      label={iLista ? segment : `Tidigare: ${segment}`}
      icon={iLista ? <Prick farg={segmentColor(segment)} /> : undefined}
      sx={{ height: liten ? 16 : 20, fontSize: liten ? '0.58rem' : '0.68rem', bgcolor: 'rgba(0,0,0,0.05)',
        fontStyle: iLista ? 'normal' : 'italic', '& .MuiChip-icon': { ml: 0.75, mr: -0.25 } }} />
  );
}
